









































































































import Vue from "vue";
import { columns } from "./components/custom";
import {
  UserServiceProxy,
  MasterlinkUserServiceProxy
} from "@/service-proxies/app-v2/user.service-proxies";
import { AuthorityDomainServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import AddEdit from "./components/AddEdit.vue";
import ViewEdit from "./components/ViewEdit.vue";
import {
  OrganizationServiceProxy,
  PostServiceProxy,
  DeptVO
} from "@/service-proxies/app-v2/system.service-proxies";
import { getLocalStorage } from "@/utils/storage";
import getScrollY from '@/utils/scroll'
const userservice = new UserServiceProxy();
const MasterlinkUserService = new MasterlinkUserServiceProxy();
const authorityDomainService = new AuthorityDomainServiceProxy();
const oSProxy = new OrganizationServiceProxy();
const pSProxy = new PostServiceProxy();


export default Vue.extend({
  components: {
    AddEdit,
    ViewEdit
  },
  data() {
    return {
      data: [], // 表单数据
      totalContent: 0, // 表单列表数
      fitler: {
        // 查询条件
        size: 30,
        current: 1,
        displayName: "",
        deptid: undefined,
        code: ""
      },
      loading: false,
      selectedRowKeys: [],
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
      },
      detailtitle: "",
      addeditshow: false,
      detailshow: false,
      editdata: {}, // 编辑数据
      Rowkey: "", // 所选表单行
      deptList: [], // 组织树结构
      organizeData:[],
      positionData: [],
      scrollY: 0
    };
  },
  computed: {
    columns() {
      return columns.map(item => {
        return {
          ...item,
          title: this.$t(item.title)
        };
      }); // 表单配置
    },
    rowSelection() {
      const { selectedRowKeys }: any = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: any) => {
          this.selectedRowKeys = selectedRowKeys;
        },
        getCheckboxProps: (record: any) => ({
          props: {
            disabled: record.account && record.account.toLowerCase() === "admin" // Column configuration not to be checked,
          },
          style: {
            display: record.id ? 'block' : 'none'
          }
        })
      };
    },
    hasselectedRowKeys() {
      const { selectedRowKeys }: any = this;
      return selectedRowKeys.length === 0;
    }
  },
  created() {
    this.fitler.current = 1;
    this.fitler.displayName = "";
    this.fitler.code = "";
    this.getlist();
  },
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },

    load() {
      this.fitler.current = 1;
      this.getlist();
    },
    getlist() {
      this.data = [];
      this.deptList = [];
      this.selectedRowKeys = [];
      MasterlinkUserService.page(
        this.fitler.current,
        this.fitler.deptid,
        this.fitler.code,
        this.fitler.size,
      ).then((res: any) => {
        if (res.data.records) {
          console.log(res.data,'datt')
          this.totalContent = res.data.total;
          // this.data = res.data.records;

          let dataLength = res.data.records.length;
          let copy = JSON.parse(JSON.stringify(res.data.records));
          let needPush = 0;
          if(dataLength < 30) {
            needPush = 30 - dataLength;
            for(var k=0; k<needPush; k++) {
              let obj = {
                // id: 'none'
                account: 'admin'
              }
              copy.push(obj)
            }
          }

          this.data = JSON.parse(JSON.stringify(copy));
          console.log(this.data)
          this.scrollY = getScrollY('black-main',this.data.length)
        }
      });
      authorityDomainService.getEnableTreeList().then(res => {
        const value: any = res.data;
        value.forEach((element: DeptVO) => {
          this.deptList.push(this.createNode(element));
        });
      });
      const userInfo = getLocalStorage('USER_INFO')
      oSProxy.tree(userInfo.tenant_id).then(res=> {
        this.organizeData = [this.treeNode(res.data[0])]
      })
      pSProxy.select(userInfo.tenant_id).then(res=> {
        this.positionData = res.data
      })
    },
    findOrginzation(value){
      let name = ''
      const target = this.findname(this.organizeData,value)
      if(target){
        name = target.title
      }
      return name
    },
    findname(tree,value){
      let target = undefined
      tree.forEach(element => {
        if(element.key === value){
          target = element
        } else {
          if(element.children && element.children.lenght){
            this.findname(element.children)
          } else {
            target = undefined
          }
        }
      });
      return target
    },
    // 处理树结构
    createNode(item: any) {
      const key = item.id;
      const title = item.title;
      const value = item.id;
      const children = item.children;

      const node = {
        key: key,
        value: value,
        title: title,
        children: children
      };

      if (children != null) {
        const length = children.length;
        if (length > 0) {
          const childrenList = [];
          for (let i = 0; i < length; i++) {
            childrenList[i] = this.createNode(children[i]);
          }

          node.children = childrenList;
        }
      }
      return node;
    },
    treeNode(res) {
      const node = {
        title: res.title,
        value: res.id,
        key: res.id,
        pId: res.parentId,
        children: []
      }
      if (res.children && res.children.length) {
        for (let i = 0; i < res.children.length; i++) {
          node.children.push(this.treeNode(res.children[i]))
        }
      }
      return node
    },
    rowClick(record: any) {
      return {
        on: {
          click: () => {
            this.editdata = {};
            this.detailshow = true;
            this.Rowkey = record.id;
            this.detailtitle = record.account;
            this.editdata = record;
          }
        }
      };
    },
    handleEdit(record: any) {
      if (this.detailshow) {
        this.$confirm({
          title: this.$t("switch_tips_title"),
          content: this.$t("switch_tips_content"),
          onOk: () => {
            this.editdata = {};
            this.detailshow = true;
            this.Rowkey = record.id;
            this.detailtitle = record.account;
            this.editdata = record;
          },
          onCancel() {
            return;
          }
        });
      } else {
        this.editdata = {};
        this.detailshow = true;
        this.Rowkey = record.id;
        this.detailtitle = record.account;
        this.editdata = record;
      }
    },
    pageIndexchange(current: any) {
      this.fitler.current = current;
      this.getlist();
    },
    handleadd() {
      this.addeditshow = true;
    },
    checklength(msg: string | undefined): string {
      if (this.hasselectedRowKeys) {
        this.$message.warning(msg);
        return "";
      }
      const Ids: string = this.selectedRowKeys.join(",");
      return Ids;
    },
    handledelete() {
      const Ids = this.checklength(
        this.$t("page_user_management_account_to_delete")
      );
      if (!Ids) return;
      userservice
        .remove(Ids)
        .then((res: any) => {
          this.$message.success(
            this.$t("page_user_management_delete_succeeded")
          );
          this.load();
        })
        .catch((res: any) => {
          this.$message.error(
            this.$t("page_user_management_delete_unsuccessful")
          );
        });
    },
    handlereload() {
      const Ids = this.checklength(
        this.$t("page_user_management_account_to_reset")
      );
      if (!Ids) return;
      userservice
        .resetPassword(Ids)
        .then(res => {
          this.$message.success(
            this.$t("page_user_management_reset_successful")
          );
          this.load();
        })
        .catch(res => {
          this.$message.error(
            this.$t("page_user_management_reset_unsuccessful")
          );
        });
    },
    handlesearch(value: any) {
      this.fitler.current = 1;
      this.fitler.code = value;
      this.getlist();
    },
    closemodal(value: boolean) {
      this.addeditshow = false;
      if (value) {
        this.load();
      }
    },
    closedetail(value: boolean) {
      this.detailshow = false;
      if (value) {
        this.getlist();
      }
    },
    totalFanyi(number: any) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    }
  }
});
